import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import find from 'lodash/find';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import isFunction from 'lodash/isFunction';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Store from 'yoda-core-components/lib/assets/svg/Store.svg';
import OnlineOnly from 'yoda-site-components/lib/assets/svg/sdpu-truck.svg';
import TooltipIcon from 'yoda-core-components/lib/assets/svg/tooltip-Question.svg';
import InfoLine from 'yoda-core-components/lib/assets/svg/InfoLine.svg';
import Button from 'yoda-core-components/lib/components/Button/Button';
import { SessionStorage } from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import RadioButton from 'yoda-core-components/lib/components/RadioButton/radio';
import { selectedProtectionPlanWrapper } from 'yoda-site-components/lib/selectors/PdpNameSpaceSelector';
import FindStoresAction from 'yoda-site-components/lib/actions/FindStoresAction';
import { selectQueryParams } from 'yoda-site-components/lib/selectors/QuerySelector';
import selectStoreData from 'yoda-site-components/lib/actions/AnalyticsAction';
import {
    FIND_STORE_THEMES_PDP,
    FIND_STORES_PAGE_SIZE,
} from 'yoda-site-components/lib/common/Constants';
import ProductConstantsSite from 'yoda-site-components/lib/common/ProductConstants';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import {
    selectPreferencesMaxOrderQuantity,
    selectFeatureFlags,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import {
    initProductOptions,
    selectedProductSkus,
} from 'yoda-site-components/lib/selectors/ProductOptionsSelector';
import selectAdditionalProtectionPlans from 'yoda-site-components/lib/selectors/protectionPlan/selectAdditionalProtectionPlans';
import { messagesActions } from 'yoda-site-components/lib/components/Messages';
import { getSdpuStoreData } from 'yoda-site-components/lib/actions/SdpuStoreInfoAction';
import getBOPISMessage from 'yoda-site-components/lib/selectors/BOPISMessageSelector';
import productPricingSelector, {
    bopisPromotionMessageSelector,
} from 'yoda-site-components/lib/selectors/ProductPricingSelector';
import IconTooltip from 'yoda-account-components/lib/components/IconTooltip/IconTooltip';
import { withRouter } from 'react-router';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import YodaTooltipLazy from 'yoda-site-components/lib/components/YodaTooltip/YodaTooltipLazy';
import { getDeliveryDateAnalytics } from 'yoda-site-components/lib/helpers/GetDeliveryDateAnalytics/getDeliveryDateAnalytics';
import FreeShippingThreshold from 'yoda-checkout-components/lib/components/FreeShippingThreshold/FreeShippingThreshold';
import { STORE_MODAL_ADD_TO_CART_MESSAGES_ID } from '../AddToCart/AddToCart.config';
import withAddToCartHOC from '../AddToCart/withAddToCartHOC';
import HolidayMessaging from '../HolidayMessaging/HolidayMessagingLazy';
import { selectSkuIds } from '../../selectors/Bundle/BundleProductOptionsSelector';
import getHolidayMessage from '../../selectors/HolidayMessagingSelector';
import {
    deliveryOptionSelectedName,
    selectedItemAvailability,
    selectedItemBopisAvailability,
    stopOOSStoreTooltip,
} from '../../actions/DeliveryOptionAction';
import {
    sameDayPickupAnalytics,
    checkAvailabilityAnalytics,
    cartAddAnalytics,
    cartUpdateAnalytics,
    pdpPSCSKUAvailability,
} from '../../actions/AnalyticsAction';
import VisitStoreToPurchase from '../VisitStoreToPurchase/VisitStoreToPurchaseLazy';
import deliveryOptions, {
    isStoreAvailable as selectAvailableStore,
    isSameDayPickupQuantityAllowed as selectSamedayPickupQuantity,
} from '../../selectors/delivery/deliverOptionsSelector';
import ProductConstants from '../../helpers/ProductConstants';
import { protectionPlanErrorMessage } from '../../validation/isValidAddToCart';
import { scrollToFirstMessage } from '../../helpers/AddToHelpers';
import * as styles from './DeliveryOption.css';

const {
    STORE_PICKUP_LABEL,
    NOT_AVAILABLE_SHORT,
    SAMEDAYPICKUP_FLAG,
    NOTAVAILABLE,
    DISABLED,
    SHIPTOHOME: SHIPTOHOMELABEL,
    CHANGE_STORE_BTN,
    SELECT_A_STORE_BTN,
} = ProductConstants;
const cx = classNames.bind(styles);
const storeModalDeliveryOption = {
    isStoreModalAtc: true,
};
const SHIPTOHOME = 'shiptohome';

/* istanbul ignore next */
export class DeliveryOption extends Component {
    static defaultProps = {
        actions: {},
        productDetails: {},
        settings: {},
        shipToHomeOrStore: {},
        sameDayPickUp: {},
        deliveryOption: {},
        productOptions: {},
        selectedProduct: {},
        query: {},
        deliveryZipcode: '',
        selectedStore: {},
        findStoresDetails: {},
        deviceType: {},
        onlineOnlyIcon: true,
        featureFlags: {},
        bopisMessage: null,
        queryParams: {},
        isAvailableStore: NOT_AVAILABLE_SHORT,
        isAllowedSamedayPickupQuantity: false,
        additionalProtectionPlans: [],
        selectedProtectionPlan: '',
        messagesTexts: {},
        holidayMessage: {},
        addToCart: {
            isAddToCartSuccess: false,
            isUpdateCartSuccess: false,
            isStoreModalAtc: false,
        },
        addToCartMessages: [],
        addProductToCart: null,
        selectedSkuIds: [],
        cartDetails: {
            deliveryOption: {
                label: '',
            },
        },
        sdpuStoreDetails: {},
        prerenderedOptions: false,
        locationServiceStoreInfo: {},
        location: {},
        router: {},
        toolTipDisplayed: false,
        customOptions: {},
        pricingDetails: {},
        bopisPromotionMessage: [],
        promiseOptions: {},
        congruentSelected: {},
        showFreeShipSignIn: false,
        irisRewardCustomerThreshold: '',
        enableFSHBanner: false,
        userState: '0',
        preferences: {},
        hostname: 'www.jcpenney.com',
    };

    static propTypes = {
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        settings: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        selectedProduct: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        shipToHomeOrStore: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        sameDayPickUp: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        deliveryOption: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        productOptions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        query: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        addToCartMessages: PropTypes.oneOfType([PropTypes.array]),
        deliveryZipcode: PropTypes.string,
        selectedQuantity: PropTypes.number.isRequired,
        selectedStore: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        findStoresDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        onlineOnlyIcon: PropTypes.bool,
        queryParams: PropTypes.oneOfType([PropTypes.object]),
        deviceType: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
        maxOrderQuantity: PropTypes.number.isRequired,
        featureFlags: PropTypes.oneOfType([PropTypes.object]),
        bopisMessage: PropTypes.string,
        isAvailableStore: PropTypes.string,
        isAllowedSamedayPickupQuantity: PropTypes.bool,
        additionalProtectionPlans: PropTypes.oneOfType([PropTypes.array]),
        selectedProtectionPlan: PropTypes.string,
        messagesTexts: PropTypes.oneOfType([PropTypes.object]),
        addToCart: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        addProductToCart: PropTypes.func,
        selectedSkuIds: PropTypes.oneOfType([PropTypes.array]),
        holidayMessage: PropTypes.object,
        cartDetails: PropTypes.shape({
            deliveryOption: PropTypes.shape({
                label: PropTypes.string,
            }),
        }),
        sdpuStoreDetails: PropTypes.oneOfType([PropTypes.object]),
        prerenderedOptions: PropTypes.boolean,
        locationServiceStoreInfo: PropTypes.oneOfType([PropTypes.object]),
        location: PropTypes.oneOfType([PropTypes.object]),
        router: PropTypes.oneOfType([PropTypes.object]),
        toolTipDisplayed: PropTypes.bool,
        customOptions: PropTypes.object,
        pricingDetails: PropTypes.oneOfType([PropTypes.object]),
        bopisPromotionMessage: PropTypes.oneOfType([PropTypes.array]),
        promiseOptions: PropTypes.object,
        congruentSelected: PropTypes.object,
        showFreeShipSignIn: PropTypes.bool,
        irisRewardCustomerThreshold: PropTypes.string,
        enableFSHBanner: PropTypes.bool,
        userState: PropTypes.string,
        preferences: PropTypes.object,
        hostname: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this.state = {
            selectedOption: '',
            isBopisStoreChanged: false,
            isShipToHome: false,
            tooltipEnabled: this.props.deviceType.isDesktop,
            storeDetails: {},
            displayOptions:
                props.productOptions.pricingURL && props.productOptions.pricingURL.itemOfferingCall,
            onStoreSliderSelectStore: false,
        };

        this.isStoreApiCalled = false;
        this.isAllSKUSelected = false;
        this.onPageLoadOptions = this.state.displayOptions;
        this.isSDPUStoreSet = false; // this is to avoid locationServiceStoreInfo to be default store when SDPU storeInfo available onload.
    }

    componentWillReceiveProps(nextProps) {
        const {
            featureFlags: { enableLocationService = true },
            locationServiceStoreInfo: locationServiceStoreInfoPrev,
            sameDayPickUp: sameDayPickUpPrev,
            hostname,
        } = this.props;

        const {
            productOptions,
            shipToHomeOrStore,
            productDetails,
            skuId,
            selectedProduct,
            actions,
            addToCart,
            deliveryOption,
            locationServiceStoreInfo = {},
            sameDayPickUp: sameDayPickUpNext,
            pricingDetails,
            location,
            congruentSelected,
        } = nextProps;
        const analyticsPageName = location?.pathname;
        const isCongruent = get(congruentSelected, 'isCongruent', false);
        const productImages = get(productOptions, 'productImages', []);
        const pdpURL = get(productDetails, 'pdpURL', '');
        const productLink = hostname && pdpURL ? `https://${hostname}${pdpURL}` : '';
        if (
            (JSON.stringify(productOptions) !== JSON.stringify(this.props.productOptions) ||
                JSON.stringify(deliveryOption) !== JSON.stringify(this.props.deliveryOption)) &&
            (productOptions?.dimensions?.length === productOptions?.optionsSelected?.length ||
                productOptions?.pricingURL?.URL)
        ) {
            if (
                !isCongruent &&
                !this.state.isBopisStoreChanged &&
                ((productOptions?.isItemInStock && get(shipToHomeOrStore, 'isChecked', false)) ||
                    (!productOptions?.isItemInStock &&
                        !shipToHomeOrStore?.isChecked &&
                        (Object.keys(shipToHomeOrStore).length > 0
                            ? deliveryOption.myAlertIndicator
                            : !productOptions?.pricingURL?.URL &&
                              !deliveryOption.myAlertIndicator)))
            ) {
                actions.allSKUSelected(
                    getDeliveryDateAnalytics(
                        shipToHomeOrStore,
                        productDetails,
                        skuId,
                        selectedProduct,
                        pricingDetails,
                        [],
                        false,
                        {},
                        productImages,
                        productLink
                    )
                );
            }
            if (
                !isCongruent &&
                !this.state.isBopisStoreChanged &&
                (this.isAllSKUSelected ||
                    productOptions?.dimensions?.length ===
                        productOptions?.optionsSelected?.length) &&
                !productOptions?.isItemInStock
            ) {
                let name = '';
                let linktext = '';
                if (productOptions?.pricingURL?.URL && Object.keys(deliveryOption).length > 0) {
                    name = 'PDP: product selection: Product OOS';
                    linktext = 'OOS Message displayed';
                    actions.pdpPSCSKUAvailability({ name, linktext, analyticsPageName });
                } else if (!productOptions?.pricingURL?.URL) {
                    name = 'PDP: product selection: NA product';
                    linktext = 'NA product Message displayed';
                    actions.pdpPSCSKUAvailability({ name, linktext, analyticsPageName });
                }
            }
        }

        if (
            JSON.stringify(deliveryOption) !== JSON.stringify(this.props.deliveryOption) ||
            JSON.stringify(shipToHomeOrStore) !== JSON.stringify(this.props.shipToHomeOrStore)
        ) {
            this.setState({
                isBopisStoreChanged: false,
            });
        }

        if (sameDayPickUpPrev.isChecked !== sameDayPickUpNext.isChecked) {
            const isSelectedItemBopisAvailable = sameDayPickUpNext.isChecked;
            this.props.actions.selectedItemBopisAvailability({ isSelectedItemBopisAvailable });
        }

        if (locationServiceStoreInfo.storeName && isEmpty(this.props.selectedStore)) {
            const locationServiceStoreInfoModified = {
                ...locationServiceStoreInfo,
                id: locationServiceStoreInfo.storeId,
            };
            this.props.actions.selectStore({
                payload: {
                    ...locationServiceStoreInfoModified,
                },
                fromMiniPDP: false,
            });
        }

        if (!isEqual(locationServiceStoreInfo, this.props.locationServiceStoreInfo)) {
            if (
                enableLocationService &&
                (!this.isSDPUStoreSet ||
                    locationServiceStoreInfo.storeId !== locationServiceStoreInfoPrev.storeId)
            ) {
                const {
                    storeId = '',
                    storeName = '',
                    zipcode: zipCode,
                    curbsidePickupIndicator,
                } = locationServiceStoreInfo;
                if (storeId && storeName && zipCode) {
                    this.props.actions.getSdpuStoreData({
                        storeId,
                        storeName,
                        zipCode,
                        curbsidePickupIndicator,
                    });
                    this.isSDPUStoreSet = true;
                }
            }
        }

        if (this.optionsContainer) {
            if (this.isPricingApplied()) {
                if (Object.keys(shipToHomeOrStore).length && !this.isAllSKUSelected) {
                    this.aproximateExpanding();
                }
            }

            if (
                nextProps.customOptions.pricingURL &&
                !this.isPricingApplied() &&
                this.isAllSKUSelected
            ) {
                this.collapseSection(this.optionsContainer, { isExpand: true, changeFlag: true });
            }
            if (this.state.displayOptions && !this.isPricingApplied()) {
                this.collapseSection(this.optionsContainer);
                this.isAllSKUSelected = false;
                this.setState({ displayOptions: false });
            }
        }

        /* istanbul ignore next */
        if (
            productOptions.pricingURL &&
            productOptions.pricingURL.itemOfferingCall &&
            (!isEqual(nextProps.deliveryOption, this.props.deliveryOption) ||
                (nextProps.selectedStore.id &&
                    nextProps.selectedStore.id !== this.props.selectedStore.id) ||
                nextProps.selectedQuantity !== this.props.selectedQuantity)
        ) {
            if (!addToCart.isStoreModalAtc) {
                actions.deliveryOptionSelectedName({
                    selectedOption: this.getSelectedOption(nextProps),
                });
                this.state.onStoreSliderSelectStore &&
                    this.setState({
                        onStoreSliderSelectStore: false,
                    });
            }

            const isSelectedItemAvailable =
                shipToHomeOrStore.isChecked || nextProps.sameDayPickUp.isChecked;
            this.props.actions.selectedItemAvailability({ isSelectedItemAvailable });

            if (
                nextProps.selectedQuantity !== this.props.selectedQuantity ||
                nextProps.selectedStore.id !== this.props.selectedStore.id
            ) {
                this.setState({
                    selectedOption: this.state.selectedOption,
                });
            }
        }
        const sdpuCheckedPrev = get(this.props.promiseOptions, 'sameDayPickUp.isChecked', false);
        const sdpuCheckedNext = get(nextProps.promiseOptions, 'sameDayPickUp.isChecked', false);
        if (sdpuCheckedPrev === false && sdpuCheckedNext) {
            this.props.actions.sameDayPickupAnalytics();
        }
    }

    shouldComponentUpdate(nextProps) {
        return (
            (nextProps.productOptions.pricingURL &&
                !nextProps.productOptions.pricingURL.itemOfferingCall) ||
            nextProps.promiseOptions !== this.props.promiseOptions ||
            nextProps.toolTipDisplayed !== this.props.toolTipDisplayed ||
            nextProps.shipToHomeOrStore !== this.props.shipToHomeOrStore ||
            (!!nextProps.selectedStore.id &&
                nextProps.selectedStore.id !== this.props.selectedStore.id) ||
            nextProps.findStoresDetails.isSlidePanelOpen !==
                this.props.findStoresDetails.isSlidePanelOpen ||
            nextProps.addToCartMessages !== this.props.addToCartMessages ||
            nextProps.query.storeIds !== this.props.query.storeIds ||
            nextProps.bopisMessage !== this.props.bopisMessage ||
            nextProps.productOptions !== this.props.productOptions ||
            nextProps.deliveryOption !== this.props.deliveryOption ||
            nextProps.showFreeShipSignIn !== this.props.showFreeShipSignIn ||
            nextProps.userState !== this.props.userState ||
            nextProps.irisRewardCustomerThreshold !== this.props.irisRewardCustomerThreshold
        );
    }

    componentDidUpdate(prevProps) {
        const disabled = get(this.props, 'shipToHomeOrStore.disabled');
        const {
            productOptions: {
                pricingURL: { itemOfferingCall },
            },
            actions,
            toolTipDisplayed,
        } = this.props;
        const {
            productOptions: {
                pricingURL: { itemOfferingCall: itemOfferingCallPrev },
            },
        } = prevProps;
        // reseting deliveryOptionSelectedName in case offering call is yet to happen for the selected skus.
        if (
            itemOfferingCallPrev !== undefined &&
            itemOfferingCallPrev !== itemOfferingCall &&
            !itemOfferingCall
        ) {
            actions.deliveryOptionSelectedName({ selectedOption: '' });
        }
        if (!this.timer && !toolTipDisplayed && disabled === DISABLED && this.toolTipNode) {
            this.toolTipNode.classList.add(cx('showToolTip'));
            this.optionsContainer && this.optionsContainer.classList.add(cx('enableOverflow'));
            this.timer = setTimeout(() => {
                this.optionsContainer &&
                    this.optionsContainer.classList.remove(cx('enableOverflow'));
                this.toolTipNode.classList.remove(cx('showToolTip'));
                actions.stopOOSStoreTooltip({ toolTipDisplayed: true });
            }, 5000);
        }
    }

    getSelectedOption = (props) => {
        const {
            sameDayPickUp: { availabilityMessage = '', isChecked },
            sdpuStoreDetails,
            query,
        } = props;
        const { selectedOption: selectedOptionCurrState, isShipToHome } = this.state;
        let selectedOption = SHIPTOHOME;
        if (
            (query.deliveryOption === 'BOPIS' && availabilityMessage !== NOTAVAILABLE) ||
            (query.storeIds &&
                availabilityMessage !== NOTAVAILABLE &&
                sdpuStoreDetails.id &&
                !isShipToHome)
        ) {
            selectedOption = SAMEDAYPICKUP_FLAG;
        } else {
            // when selecting dimensions based on bopis availability for the selected store we set cannot be bopis.
            const cannotBeBopis =
                availabilityMessage === NOTAVAILABLE &&
                selectedOptionCurrState === SAMEDAYPICKUP_FLAG;
            selectedOption =
                selectedOptionCurrState && selectedOptionCurrState !== '' && !cannotBeBopis
                    ? selectedOptionCurrState
                    : SHIPTOHOME;
            // when sameday pickup radio button is checked.
            selectedOption = isChecked ? SAMEDAYPICKUP_FLAG : SHIPTOHOME;
        }

        return selectedOption;
    };

    getProductInfo = () => {
        const { productDetails, productOptions } = this.props;
        const productDetailsImage =
            productDetails.images && productDetails.images.length
                ? productDetails.images[0].url
                : '';
        return productDetails.id
            ? [].concat({
                  name: productDetails.name,
                  imageURL:
                      productOptions.productImages && productOptions.productImages.length
                          ? productOptions.productImages[0].url
                          : productDetailsImage,
                  skus:
                      productOptions.filteredItems && productOptions.filteredItems.length
                          ? productOptions.filteredItems[0].id
                          : null,
              })
            : null;
    };

    onSliderSelectStore = (params) => {
        this.setState({
            onStoreSliderSelectStore: true,
        });
        this.props.actions.selectStore({ ...params, fromMiniPDP: false });
        this.props.actions.deliveryOptionSelectedName({
            selectedOption: this.getSelectedOption(this.props),
        });
    };

    onStoreModalAddToCart = (params) => {
        this.props.actions.selectStore({ ...params, fromMiniPDP: false });
    };

    /* This function implies when complete sku selection is done and sku-offering call has been made */

    isPricingApplied() {
        const { productOptions, customOptions } = this.props;
        let result = false;
        if ('selectedLotDetails' in productOptions) {
            const customOption = get(productOptions, 'selectedLotDetails.customizationModel', null);
            if (customOption && customOption.type === ProductConstantsSite.GIFTCARD) {
                return true;
            }
            const isCustomOption = customOption !== null;
            const optionsObject = isCustomOption ? customOptions : productOptions;
            const isItemOfferingCall = get(optionsObject, 'pricingURL.itemOfferingCall');
            const customRequired =
                customOptions &&
                customOptions.options &&
                customOptions.options.fields.filter((option) => option.required === true);
            const selectedCustomOption =
                customOptions &&
                customOptions.selectedCustomOptions &&
                customOptions.selectedCustomOptions;
            if (
                get(optionsObject, 'pricingURL.customizationType') === ProductConstantsSite.HEMMING
            ) {
                customRequired &&
                    customRequired.length &&
                    customRequired.forEach((option) => {
                        return !isEmpty(
                            find(
                                selectedCustomOption,
                                (selectedOption) => selectedOption.type === option.name
                            )
                        );
                    });
            }
            result = isItemOfferingCall;
        }
        return result;
    }

    removeAtcErrorMsg = () => {
        this.props.actions.removeAllMessages({
            section: STORE_MODAL_ADD_TO_CART_MESSAGES_ID,
            sourceMiniPDP: false,
        });
    };

    handleAnalytics = (e) => {
        if (
            e.currentTarget.innerHTML === STORE_PICKUP_LABEL ||
            e.currentTarget.innerHTML === 'Check Availability at Other Stores'
        ) {
            this.props.actions.checkAvailabilityAnalytics();
        }
    };

    /**
     * Function to trigger onChange callback function registered
     * by app components
     */
    handleChange = (event, isTracked = true) => {
        const { target } = event;
        const name = target.id;
        const {
            actions,
            isAvailableStore,
            isAllowedSamedayPickupQuantity,
            sdpuStoreDetails,
        } = this.props;
        this.setState({
            selectedOption: name,
            isShipToHome: name === SHIPTOHOME,
            isBopisStoreChanged: !isEmpty(sdpuStoreDetails),
        });
        !isEmpty(sdpuStoreDetails) &&
            actions.deliveryOptionSelectedName({
                selectedOption: name,
            });
        if (isTracked) {
            if (
                name === SAMEDAYPICKUP_FLAG &&
                (isAvailableStore === NOT_AVAILABLE_SHORT || !isAllowedSamedayPickupQuantity)
            ) {
                this.handleFindStores(event);
            }
            this.handleAnalytics(event);
        }
    };

    getFindStoresPayload = (zipCode) => {
        const {
            featureFlags: { enableFindAStorePageRedesign = true },
            preferences,
            productOptions: { filteredItems },
        } = this.props;
        return {
            zipCode,
            miles: (enableFindAStorePageRedesign && preferences && preferences.defaultRadius) || 25,
            showAvailable: false,
            pageSize: FIND_STORES_PAGE_SIZE, // number of stores to request per request
            skus: filteredItems[0].id,
        };
    };

    handleFindStores = (e) => {
        const {
            actions,
            additionalProtectionPlans,
            selectedProtectionPlan,
            messagesTexts: { ProtectionPlanMessages },
            isAvailableStore,
            locationServiceStoreInfo: { inputZipCode = '' } = {},
            selectedQuantity,
            findStoresDetails,
            productOptions: { filteredItems },
        } = this.props;

        if (additionalProtectionPlans.length && !selectedProtectionPlan) {
            const errorMessage = protectionPlanErrorMessage(ProtectionPlanMessages);
            actions.addMessage({ ...errorMessage, sourceMiniPDP: false });
            setImmediate(scrollToFirstMessage);
            return null;
        }
        let searchZip = '';
        if (inputZipCode) {
            searchZip = inputZipCode;
        } else {
            searchZip = get(findStoresDetails, 'zipCode', '');
        }
        if (searchZip) {
            actions.findStores(this.getFindStoresPayload(searchZip));
        }

        this.removeAtcErrorMsg();
        actions.setFindStoreSliderProps({
            productDetails: this.getProductInfo(),
            enableSlimFindStores: true,
            findStoresAction: actions.findStores,
            selectActionCallback: this.selectActionCallback,
            theme: FIND_STORE_THEMES_PDP,
            hideContentScroll: true,
            selectedQuantity,
            isMounted: findStoresDetails.isSlidePanelOpen,
            selectStoreAction: this.onSliderSelectStore,
            fromMiniPDP: false,
            skuSelected: filteredItems[0].id,
        });
        actions.openSlidePanel();
        if (isAvailableStore !== NOT_AVAILABLE_SHORT) {
            this.handleAnalytics(e);
        }
        return null;
    };

    selectActionCallback = () => {
        const { actions } = this.props;
        this.handleChange({ target: { id: SAMEDAYPICKUP_FLAG } }, false);
        const keyValue = SessionStorage.getData('setBopisDefaultStore', true);
        /* istanbul ignore next */
        if (isEmpty(keyValue)) {
            actions.triggerBopisDefaultStoreChange();
            SessionStorage.setData('setBopisDefaultStore', true, true);
        } else actions.triggerBopisPickupStoreChange();
    };

    expandSection = (element, config) => {
        element.style.height = 'auto';
        element.addEventListener('transitionend', function onTransitionEnd() {
            element.removeEventListener('transitionend', onTransitionEnd);
            element.style.height = null;
        });

        this.isAllSKUSelected = !config.changeFlag;
    };

    collapseSection = (element, config = {}) => {
        const sectionHeight = element.scrollHeight;
        const elementTransition = element.style.transition;

        element.style.transition = '';
        if (element.style.height !== '0px' && !this.state.displayOptions) {
            requestAnimationFrame(() => {
                element.style.height = `${sectionHeight}px`;
                element.style.transition = elementTransition;
            });
        }

        return config.isExpand ? this.aproximateExpanding(config) : null;
    };

    aproximateExpanding = (config = {}) => {
        this.onPageLoadOptions = false;
        this.setState({ displayOptions: !config.changeFlag }, () => {
            this.forceUpdate();
            this.expandSection(this.optionsContainer, config);
        });
    };

    optionContainerReference = (ref) => {
        this.optionsContainer = ref;
    };

    renderSurcharges = (messagesTexts, surcharges) => {
        const { sameDayPickUp } = this.props;
        const samedayPickupLabelStyle = dt(['lg:pl-9', 'smMd:pl-8']);
        return (
            <p
                className={`${dt(['smMd:text-base', 'text-black', 'leading-5', 'block', 'mt-1'])} ${
                    (sameDayPickUp?.label !== '' && sameDayPickUp?.isVisitStoreToPurchase) ||
                    sameDayPickUp?.label === ''
                        ? ''
                        : samedayPickupLabelStyle
                }
                `}
            >
                {surcharges}
                &nbsp;
                <YodaTooltipLazy
                    renderTooltipContents={messagesTexts?.SurchargeMessage?.oversizedItems}
                    tooltipContentClass={dt([
                        'sm:!bg-gray-70',
                        'sm:!p-3',
                        'sm:!rounded',
                        'sm:!text-white',
                        'sm:!border-gray-70',
                        'sm:!w-[280px]',
                        'md:!w-[340px]',
                        'sm:!-right-4',
                        'sm:after:!border-t-gray-70',
                    ])}
                    direction="Topright"
                    tooltipPlacement="Left"
                    triggerEventName="click"
                >
                    <a className={cx('tooltipIcon')}>
                        <Icon
                            data-automation-id="tooltip-surcharge"
                            iconType="svg"
                            className={cx('tooltip-icon')}
                            width="20"
                            height="20px"
                            viewBox="0 0 45 45"
                        >
                            <TooltipIcon />
                        </Icon>
                    </a>
                </YodaTooltipLazy>
            </p>
        );
    };

    renderRadioButton = (isDisabled, isChecked, id, label) => {
        if (
            this.props.productOptions.pricingURL &&
            this.props.productOptions.pricingURL.itemOfferingCall
        ) {
            return (
                <label
                    htmlFor={id}
                    className={`${cx('deliveryOptionLabelContainer')} ${dt(['flex', 'w-full'])}`}
                    data-automation-id="deliveryOptionRadioBtnContainer"
                >
                    <RadioButton
                        id={id}
                        name="deliveryoption"
                        checked={isChecked}
                        disabled={isDisabled}
                        isDeliveryDisabled={isDisabled}
                        onClick={this.handleChange}
                        className={cx('radioLabelCustom')}
                    />
                    <div
                        className={cx('radioIndicator')}
                        data-automation-id="deliveryOptionRadioBtn"
                    />
                    <div
                        className={`${cx('radioLabel')} ${dt(['w-full'])}`}
                        data-automation-id="deliveryOptionRadioBtnLabel"
                    >
                        {label}
                    </div>
                </label>
            );
        }

        return null;
    };

    renderVisitToStore = (bopisMessage, isVisitStoreWithFlag) => (
        <div
            className={cx('visitStore-wrap', {
                'visitStoreWrap-desktop': this.props.deviceType.isDesktop,
            })}
        >
            <ErrorBoundary>
                <VisitStoreToPurchase
                    bopisMessage={bopisMessage}
                    isVisitStoreWithFlag={isVisitStoreWithFlag}
                />
            </ErrorBoundary>
        </div>
    );

    renderShipToHomeOrStore(
        shipToHomeOrStore,
        sameDayPickUp = {},
        bopisEligibility,
        deviceType,
        messagesTexts
    ) {
        const { isChecked } = shipToHomeOrStore;
        const { canShipToStore } = shipToHomeOrStore;
        const sameDayPickUpEligible = sameDayPickUp.label !== '';
        const { deliveryDate = true } = this.props.featureFlags;
        const label = (
            <div
                className={cx('shipToHomeOrStoreContainer', {
                    withSurcharge: shipToHomeOrStore.surcharges,
                })}
            >
                <div
                    className={`${cx('deliveryOptions')} ${dt([
                        'flex',
                        'lg:flex-row',
                        'lg:items-start',
                        'flex-wrap',
                        'smMd:!flex-col',
                    ])}`}
                >
                    <div
                        data-automation-id="ship-home-store"
                        className={cx('shipToHomeWrap', {
                            disabled: shipToHomeOrStore.disabled === DISABLED || false,
                        })}
                    >
                        <span
                            className={cx({
                                labelSize: true,
                                labelWeight: !shipToHomeOrStore.disabled,
                                labelPadding: !bopisEligibility,
                            })}
                        >
                            {`${SHIPTOHOMELABEL} ${canShipToStore ? 'or ' : ''}`}
                            {canShipToStore && (
                                <span
                                    className={`${cx('shiftToStoreLabel')} ${dt([
                                        'smOnly:inline-block',
                                    ])}`}
                                >
                                    {shipToHomeOrStore.label}{' '}
                                </span>
                            )}
                        </span>
                    </div>
                    {shipToHomeOrStore.deliveryMessage && (
                        <div className={cx('deliveryMessage-wrap')}>
                            {deliveryDate ? (
                                <p
                                    className={`${cx('deliveryMessage')} ${dt([
                                        'inline-block',
                                        'lg:text-sm',
                                    ])}`}
                                    data-automation-id="est-deliverydates"
                                    dangerouslySetInnerHTML={{
                                        __html: shipToHomeOrStore.deliveryMessage,
                                    }}
                                />
                            ) : null}
                        </div>
                    )}
                    {shipToHomeOrStore.maxQuantity && !deviceType.isDesktop && (
                        <span
                            className={`${cx('quantityLeft')} ${dt([
                                'pl-1',
                                'smMd:pl-0',
                                'smMd:w-full',
                            ])}`}
                        >
                            {`Hurry, ${shipToHomeOrStore.maxQuantity}`}
                        </span>
                    )}
                </div>
                {shipToHomeOrStore.availabilityMessage && (
                    <div
                        className={cx('outOfStock')}
                        data-automation-id={`ship-home-${shipToHomeOrStore.availabilityMessage}`}
                    >
                        {shipToHomeOrStore.availabilityMessage}
                    </div>
                )}

                {sameDayPickUp.channelOfferingLabel ? (
                    <div className={cx('deliveryOptions', 'left')}>
                        <span
                            className={dt([
                                'leading-5',
                                'text-black',
                                'text-gray-60',
                                'smMd:!text-base',
                                'flex',
                                'flex-row',
                                'flex-wrap',
                                'smMd:!flex-col',
                            ])}
                        >
                            {sameDayPickUp.channelOfferingLabel}
                        </span>
                    </div>
                ) : (
                    ''
                )}
                {shipToHomeOrStore.maxQuantity && deviceType.isDesktop && (
                    <span className={cx('quantityLeft', 'shipToHomeStoreQty')}>
                        {`Hurry, ${shipToHomeOrStore.maxQuantity}`}
                    </span>
                )}
            </div>
        );

        let shipToHomeOrStoreEl = label;

        if (sameDayPickUp.label !== '' && bopisEligibility) {
            shipToHomeOrStoreEl = this.renderRadioButton(
                shipToHomeOrStore.isRadioButtonDisabled,
                isChecked,
                SHIPTOHOME,
                label
            );
        }
        return (
            <div
                className={`${cx('shipToHome', 'radioButton', {
                    sameDayPickUpNotEligible: !sameDayPickUpEligible,
                    deliveryMsg: sameDayPickUp.channelOfferingLabel,
                    shipToHomeNoBopis: !bopisEligibility,
                    sthMargin:
                        deviceType.isDesktop && !isEmpty(sameDayPickUp.label) && bopisEligibility,
                })} ${dt(['flex-1'])}`}
                data-automation-id="ship-to-home"
            >
                {shipToHomeOrStore.label !== '' ? shipToHomeOrStoreEl : ''}
                {shipToHomeOrStore.surcharges ? (
                    <div className={cx('surchargeContainer', { sameDayPickUpEligible })}>
                        {this.renderSurcharges(messagesTexts, shipToHomeOrStore.surcharges)}
                    </div>
                ) : null}
            </div>
        );
    }

    renderSameDayPickupAndShipToHome(
        availabilityMessage = '',
        bopisEligibility,
        showSignInMessage
    ) {
        const {
            shipToHomeOrStore,
            sameDayPickUp,
            deviceType,
            bopisPromotionMessage,
            sdpuStoreDetails,
            messagesTexts,
            featureFlags: { bopis = true, enableBopisIncentive },
        } = this.props;
        const SameDayPickUpLabel = sameDayPickUp.label;
        const label = (
            <div
                className={`${cx('deliveryOptions')} ${dt([
                    'flex',
                    'smMd:!text-base',
                    'lg:text-small',
                    'items-start',
                    'lg:flex-row',
                    'lg:items-start',
                    'flex-wrap',
                    'smMd:!flex-col',
                ])}`}
            >
                <div className={cx('samedayPickup-wrap')} data-automation-id="sameday-pickup-label">
                    <span
                        className={cx({
                            labelPadding: !bopisEligibility,
                        })}
                    >
                        {SameDayPickUpLabel && isFunction(SameDayPickUpLabel) ? (
                            <SameDayPickUpLabel sameDayPickUp={sameDayPickUp} />
                        ) : (
                            SameDayPickUpLabel
                        )}
                    </span>
                </div>
            </div>
        );
        let { isRadioButtonDisabled } = sameDayPickUp;
        if (
            sameDayPickUp.availabilityMessage === NOTAVAILABLE &&
            sameDayPickUp.disabled === DISABLED
        ) {
            isRadioButtonDisabled = true;
        }
        const commonServiceStoreDetails = this.getStoreDetailsFromCommonService();
        return (
            <div
                className={`${cx('deliveryOptionsContainer')} ${
                    deviceType.isDesktop ? dt(['flex']) : dt(['block'])
                } ${dt(['w-full', 'text-small', 'smMd:!text-base'])}`}
            >
                {Object.keys(sameDayPickUp).length > 0 &&
                sameDayPickUp.label !== '' &&
                bopisEligibility ? (
                    <div className={`${cx('sameDayPickup')} ${dt(['flex-1', 'mx-0', 'mb-4'])}`}>
                        <div
                            data-automation-id="same-day-pickup"
                            className={cx('radioButton', 'left')}
                        >
                            {this.renderRadioButton(
                                isRadioButtonDisabled,
                                sameDayPickUp.isChecked,
                                SAMEDAYPICKUP_FLAG,
                                label
                            )}
                        </div>
                        <div className={dt(['lg:pl-9', 'smMd:pl-9'])}>
                            <p
                                className={`${cx('store-availabletext-wrap')} ${dt([
                                    'inline-block',
                                ])}`}
                            >
                                <span
                                    className={cx({
                                        ecllipseStore:
                                            (sameDayPickUp.storeInfo &&
                                                sameDayPickUp.storeInfo !== '') ||
                                            false,
                                    })}
                                >
                                    {commonServiceStoreDetails.storeName ? (
                                        <span
                                            className={cx('storeInfo')}
                                            data-automation-id={`same-day-store-info-${sameDayPickUp.storeInfo}`}
                                        >
                                            <span
                                                className={dt([
                                                    'text-black',
                                                    'font-open-sans-regular',
                                                    'text-small',
                                                    'pr-1',
                                                    'smMd:text-base',
                                                ])}
                                            >
                                                {commonServiceStoreDetails.storeName}
                                                {commonServiceStoreDetails.city &&
                                                    `, ${commonServiceStoreDetails.city}`}
                                                {commonServiceStoreDetails.state &&
                                                    `, ${commonServiceStoreDetails.state}`}
                                            </span>

                                            <Button
                                                buttonType="Link"
                                                onClick={this.handleFindStores}
                                                automationId="change-store"
                                                size="Sm"
                                            >
                                                <span
                                                    className={dt([
                                                        'text-black',
                                                        'font-open-sans-regular',
                                                        'text-xsmall',
                                                    ])}
                                                >
                                                    {CHANGE_STORE_BTN}
                                                </span>
                                            </Button>
                                        </span>
                                    ) : null}
                                </span>
                            </p>
                            {!commonServiceStoreDetails.storeName ? (
                                <Button
                                    buttonType="Link"
                                    onClick={this.handleFindStores}
                                    automationId="samedayPickup"
                                    size="Sm"
                                    className={dt(['hover:!text-black', 'active:text-black'])}
                                >
                                    <span
                                        className={dt([
                                            'text-black',
                                            'font-open-sans-regular',
                                            'text-small',
                                            'hover:text-black',
                                        ])}
                                    >
                                        {SELECT_A_STORE_BTN}
                                    </span>
                                </Button>
                            ) : null}
                        </div>
                        {sameDayPickUp.availabilityMessage === NOTAVAILABLE &&
                            !isEmpty(sameDayPickUp.pickupDateMessage) && (
                                <div className={dt(['lg:pl-9', 'smMd:pl-9', 'mt-1'])}>
                                    <p
                                        className={dt([
                                            'font-open-sans-regular',
                                            'text-small',
                                            'text-gray-60',
                                            'pt-1',
                                            'smMd:text-base',
                                        ])}
                                    >
                                        {sameDayPickUp.pickupDateMessage}
                                    </p>
                                </div>
                            )}
                        {availabilityMessage && bopis && (
                            <div className={dt(['lg:pl-3', 'smMd:pl-3', 'inline-block', 'pt-1'])}>
                                {availabilityMessage}
                            </div>
                        )}
                        {!(sameDayPickUp.availabilityMessage === NOTAVAILABLE) &&
                            sdpuStoreDetails.curbsidePickupIndicator && (
                                <div className={dt(['lg:pl-7', 'smMd:pl-7', 'pt-1'])}>
                                    <p
                                        className={dt([
                                            'smMd:text-base',
                                            'lg:!text-small',
                                            'font-open-sans-regular',
                                        ])}
                                        data-automation-id="at-curbside-enhancement-message"
                                    >
                                        <span className={dt(['pr-1', 'capitalize', 'pl-2'])}>
                                            {
                                                messagesTexts.lineItemCurbSideText
                                                    .lineItemCurbSidePickupAvailable
                                            }
                                        </span>
                                        <span
                                            data-automation-id="at-curbside-info-icon"
                                            className={cx('curbsideInfoIcon')}
                                        >
                                            <IconTooltip
                                                message={
                                                    messagesTexts.lineItemCurbSideText
                                                        .lineItemCurbSideTooltipMessage
                                                }
                                                icon="info-line"
                                                iconComponent={<InfoLine />}
                                                id="tooltip"
                                                tooltipPlacement="Middle"
                                                tooltipBodyClassName={cx('curbsideInfo')}
                                                iconClass={cx('tooltipSize')}
                                                direction="Topmiddle"
                                                theme={dt(['smOnly:!w-52'])}
                                            />
                                        </span>
                                    </p>
                                </div>
                            )}

                        {/* using bopis promotion message directly from selector */}
                        {!isEmpty(bopisPromotionMessage) &&
                            !(sameDayPickUp.disabled === DISABLED) &&
                            enableBopisIncentive && (
                                <div
                                    className={dt([
                                        'pl-6',
                                        'pt-1',
                                        'lg:text-small',
                                        'smMd:text-base',
                                        'flex',
                                    ])}
                                >
                                    <div className={dt(['smMd:pl-2', 'lg:pl-1'])}>
                                        {bopisPromotionMessage[0].message}
                                    </div>
                                </div>
                            )}
                        {sameDayPickUp.quantities && (
                            <div
                                className={`${cx('quantityLeft')} ${dt([
                                    'lg:pl-9',
                                    'smMd:pl-9',
                                    'text-base',
                                ])}`}
                            >
                                {sameDayPickUp.quantities}
                            </div>
                        )}
                    </div>
                ) : (
                    ''
                )}
                <div className={`${cx('shipToHomeContainer')} ${dt(['flex-1'])}`}>
                    {shipToHomeOrStore.isShipToHomeOrStoreAvailable
                        ? this.renderShipToHomeOrStore(
                              shipToHomeOrStore,
                              sameDayPickUp,
                              bopisEligibility,
                              deviceType,
                              messagesTexts
                          )
                        : ''}
                    {showSignInMessage ? (
                        <FreeShippingThreshold
                            wrapperStyles={`${dt([
                                'flex',
                                'mt-2',
                                'items-center',
                                deviceType.isDesktop ? 'ml-6' : '',
                            ])}`}
                            renderFrom="PDP"
                        />
                    ) : (
                        ''
                    )}
                </div>
            </div>
        );
    }

    renderToolTip() {
        const storeName = get(this.props, 'sameDayPickUp.storeInfo');
        const msg = storeName
            ? 'Please select another store to check availability.'
            : 'Please select a store to check availability.';
        return (
            <div className={cx('toolTipContainer')}>
                <div
                    className={cx('toolTipBody')}
                    ref={(node) => {
                        this.toolTipNode = node;
                    }}
                >
                    <p className={cx('toolTipText')}>{msg}</p>
                </div>
            </div>
        );
    }

    renderDisplayOptions() {
        const {
            sameDayPickUp,
            shipToHomeOrStore,
            onlineOnlyIcon,
            bopisMessage,
            featureFlags,
            deviceType,
            toolTipDisplayed,
            productDetails,
            selectedSkuIds = [],
            deliveryOption,
            productOptions,
            selectedProduct = [],
            irisRewardCustomerThreshold,
            enableFSHBanner,
            userState,
        } = this.props;
        const shipping = selectedProduct[0]?.shipping;
        const bopisEligibility =
            productDetails && productDetails.bopisEligibility && get(featureFlags, 'bopis', true);
        const availabilityMessage =
            sameDayPickUp &&
            sameDayPickUp.label !== '' &&
            !(sameDayPickUp.availabilityMessage === NOTAVAILABLE) &&
            !isEmpty(sameDayPickUp.storeInfo) &&
            bopisMessage ? (
                <div className={`${cx('availabilityMessage')} ${dt(['pl-6'])}`}>{bopisMessage}</div>
            ) : null;

        const storeName = get(sameDayPickUp, 'storeInfo');
        const { enableOOSStoreTooltip = true } = featureFlags;
        const showTooltip =
            enableOOSStoreTooltip &&
            sameDayPickUp.label !== '' &&
            bopisEligibility &&
            selectedSkuIds.indexOf(deliveryOption.actualSkuId) !== -1 &&
            !toolTipDisplayed &&
            shipToHomeOrStore.disabled === DISABLED &&
            (!storeName || (sameDayPickUp.availabilityMessage !== '' && storeName !== ''));
        let renderLabel = !!sameDayPickUp.channelOfferingLabel;
        let deliveryOptionIcon = 'online-only';
        let deliveryOptionIconComponent = <OnlineOnly />;
        const { isVisitStoreToPurchase } = sameDayPickUp;
        const { visitStoreToPurchase = true } = featureFlags;
        const isVisitStoreWithFlag = isVisitStoreToPurchase && visitStoreToPurchase;
        const isGiftCard = productDetails.type === 'GIFTCARD';
        const showFreeShipSignIn =
            enableFSHBanner &&
            !isGiftCard &&
            userState !== '1' &&
            !shipping?.truckable &&
            irisRewardCustomerThreshold;
        const shippingSection = this.renderSameDayPickupAndShipToHome(
            availabilityMessage,
            bopisEligibility,
            showFreeShipSignIn && !(isVisitStoreWithFlag || renderLabel || !bopisEligibility)
        );

        if (renderLabel) {
            if (sameDayPickUp.channelOfferingLabel.toUpperCase() === 'ONLINE ONLY') {
                deliveryOptionIcon = 'online-only';
                deliveryOptionIconComponent = <OnlineOnly />;
                if (!onlineOnlyIcon) {
                    renderLabel = false;
                }
            } else {
                deliveryOptionIcon = 'store';
                deliveryOptionIconComponent = <Store />;
            }
        }

        return (
            <>
                <div
                    className={cx({
                        'deliveryOptionBorder-desktop':
                            isVisitStoreWithFlag && deviceType.isDesktop,
                    })}
                >
                    {isVisitStoreWithFlag && this.state.displayOptions
                        ? this.renderVisitToStore(bopisMessage, isVisitStoreWithFlag)
                        : ''}
                    {isVisitStoreWithFlag && !deviceType.isDesktop ? (
                        <span
                            className={`${cx('shiftTohome-visit-store-border')} ${dt([
                                'relative',
                                'block',
                                'my-4',
                                'mx-0',
                            ])}`}
                        />
                    ) : (
                        ''
                    )}
                    <div
                        className={`${cx('shippingSection', {
                            isVisitStoreToPurchase: isVisitStoreWithFlag,
                            'isVisitStore-desktop': isVisitStoreWithFlag && deviceType.isDesktop,
                        })}`}
                    >
                        <div
                            className={`${dt(['flex'])}`}
                            data-automation-id="same-day-pickup-section"
                        >
                            {showTooltip && this.renderToolTip()}
                            {renderLabel || !bopisEligibility ? (
                                <div
                                    className={`${cx('channel-offeringsvg-wrap', {
                                        disabled: shipToHomeOrStore.disabled === DISABLED || false,
                                        noVSTP: !isVisitStoreToPurchase,
                                    })} ${
                                        !productOptions?.pricingURL?.itemOfferingCall
                                            ? dt(['hidden'])
                                            : ''
                                    }`}
                                >
                                    <Icon
                                        iconType="svg"
                                        pathClassName={cx('iconPath')}
                                        className={`${cx('svg-icon')} ${dt([
                                            shipToHomeOrStore.availabilityMessage && 'opacity-40',
                                        ])}`}
                                        width="32"
                                        height="32"
                                        viewBox="0 3 40 40"
                                    >
                                        {deliveryOptionIconComponent}
                                    </Icon>
                                </div>
                            ) : (
                                ''
                            )}
                            {shippingSection}
                        </div>
                        {showFreeShipSignIn &&
                        (isVisitStoreWithFlag || renderLabel || !bopisEligibility) ? (
                            <FreeShippingThreshold
                                wrapperStyles={`${dt([
                                    'flex',
                                    'mt-2',
                                    'items-center',
                                    !productOptions?.pricingURL?.itemOfferingCall ? 'hidden' : '',
                                ])}`}
                                renderFrom="PDP"
                            />
                        ) : (
                            ''
                        )}
                    </div>
                    {sameDayPickUp.updatedAsOf && get(featureFlags, 'bopis', true) && (
                        <div className={cx('availabilityMessage')}>{sameDayPickUp.updatedAsOf}</div>
                    )}
                </div>
                {enableFSHBanner && !shipping?.truckable && !isGiftCard && !showFreeShipSignIn && (
                    <FreeShippingThreshold
                        wrapperStyles={dt(['mt-6', 'lg:mt-2', 'max-w-[395px]'])}
                        renderFrom="PDP"
                    />
                )}
            </>
        );
    }

    getStoreDetailsFromCommonService = () => {
        const { locationServiceStoreInfo = {} } = this.props;
        const storeName = locationServiceStoreInfo.storeName || '';
        const city = locationServiceStoreInfo.city || '';
        const state = locationServiceStoreInfo.state || '';
        return {
            storeName,
            city,
            state,
        };
    };

    render() {
        const { prerenderedOptions, holidayMessage, sameDayPickUp } = this.props;

        const holidayMessageData =
            holidayMessage && Object.keys(holidayMessage).length ? holidayMessage : null;
        const shouldDisplayBopusHolidayMessage =
            get(holidayMessageData, 'deliveryMethod', '') === 'bopus' &&
            sameDayPickUp.disabled !== DISABLED;
        const shouldDisplaySTHHolidayMessage =
            get(holidayMessageData, 'deliveryMethod', '') === 'shipToHome';
        return (
            <div
                ref={this.optionContainerReference}
                className={`${cx('deliveryOptionTransition')} ${dt([
                    'transition-[height]',
                    'duration-200',
                    'ease-out',
                    'h-auto',
                    'mt-6',
                ])}`}
            >
                {this.state.displayOptions &&
                    (shouldDisplaySTHHolidayMessage || shouldDisplayBopusHolidayMessage) && (
                        <ErrorBoundary>
                            <HolidayMessaging holidayMessage={holidayMessageData} />
                        </ErrorBoundary>
                    )}
                <div
                    data-automation-id="delivery-find-store"
                    className={`${cx('deliveryOptionContainer', {
                        holidayMessagingSpace: holidayMessageData,
                    })} ${dt([
                        'text-sm',
                        'font-open-sans-regular',
                        'leading-5',
                        'text-black',
                        'mt-1',
                    ])}`}
                >
                    {this.state.displayOptions &&
                        (!this.onPageLoadOptions || prerenderedOptions) &&
                        this.renderDisplayOptions()}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    productDetails: state.productDetails,
    settings: state.settings,
    shipToHomeOrStore:
        Object.keys(deliveryOptions(state).shipToHomeOrStore).length > 0
            ? deliveryOptions(state).shipToHomeOrStore
            : state.deliveryOption.shipToHomeOrStore,
    sameDayPickUp:
        Object.keys(deliveryOptions(state).shipToHomeOrStore).length > 0
            ? deliveryOptions(state).sameDayPickUp
            : state.deliveryOption.sameDayPickUp,
    deliveryOption: state.productOffering,
    productOptions: initProductOptions(ownProps.fromMiniPDP)(state),
    selectedProduct: selectedProductSkus(false)(state),
    deliveryZipcode: state.deliveryZipcode,
    selectedStore: get(state, 'selectedStore.storeDetails', {}),
    selectedQuantity: state.selectedQuantity,
    addToCartMessages: state.messages[STORE_MODAL_ADD_TO_CART_MESSAGES_ID],
    findStoresDetails: state.findStoresDetails,
    queryParams: selectQueryParams(state),
    deviceType: state?.context?.deviceType ? state.context.deviceType : {},
    maxOrderQuantity: selectPreferencesMaxOrderQuantity(state),
    promiseOptions: deliveryOptions(state),
    featureFlags: selectFeatureFlags(state),
    isAvailableStore: selectAvailableStore(state),
    isAllowedSamedayPickupQuantity: selectSamedayPickupQuantity(state),
    selectedProtectionPlan: selectedProtectionPlanWrapper(false)(state),
    additionalProtectionPlans: selectAdditionalProtectionPlans(false)(state),
    messagesTexts: state.context.messagesTexts,
    addToCart: state.addToCart,
    selectedSkuIds: selectSkuIds(state, ownProps.isBundle),
    sdpuStoreDetails: state.sdpuStoreInfo,
    holidayMessage: getHolidayMessage(state),
    locationServiceStoreInfo: state.locationServiceReducer,
    bopisMessage: getBOPISMessage(state),
    toolTipDisplayed: state.deliveryOption.toolTipDisplayed,
    customOptions: state.customOptions,
    pricingDetails: productPricingSelector(false)(state),
    bopisPromotionMessage: bopisPromotionMessageSelector(ownProps.fromMiniPDP)(state),
    preferences: state?.context?.preferences ? state.context.preferences : {},
    congruentSelected: state.congruentSelected || {},
    irisRewardCustomerThreshold:
        state?.irisPromotionalBannerData?.shippingThresholds?.rewardCustomer,
    enableFSHBanner: state?.context?.featureFlags?.enableFSHBanner,
    userState: state?.accounts?.userProfile?.userState,
    hostname: state?.context?.hostname || 'www.jcpenney.com',
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...FindStoresAction,
            checkAvailabilityAnalytics,
            sameDayPickupAnalytics,
            deliveryOptionSelectedName,
            selectedItemAvailability,
            selectedItemBopisAvailability,
            stopOOSStoreTooltip,
            cartAddAnalytics,
            cartUpdateAnalytics,
            pdpPSCSKUAvailability,
            ...selectStoreData,
            ...messagesActions,
            getSdpuStoreData,
        },
        dispatch
    ),
});

export default withRouter(
    compose(
        withAddToCartHOC(storeModalDeliveryOption),
        connect(mapStateToProps, mapDispatchToProps)
    )(DeliveryOption)
);
